common.View.create('canvas.blocks.custom.imageHeader.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            margin: 0,
            nav: true,
            dots: false,
            navContainer: this.element.find('.owl-nav')
        });
    },
});
